<script>
import { mapActions } from 'vuex';
import router from '@/router';

export default {
  data () {
    return {
      loading: false,
      error: null
    };
  },

  methods: {
    ...mapActions({ sessionLogin: 'session/login', loadUser: 'user/loadUser', setSesionInfos: 'user/setSessionInfos' }),
    login () {
      this.error = null;
      this.loading = true;

      this.sessionLogin()
        .then(success => {
          if (success) {
            return this.loadUser()
              .then(user => {
                this.setSesionInfos({ connectionTime: Date.now() });
                this.$ga.event({
                  eventCategory: 'session',
                  eventAction: 'login',
                  eventLabel: user.username
                });

                if (~user.roles.indexOf('ADD_ALI_ADHERENT_VGM')) {
                  router.push({ name: 'error-logout', query: { cause: 'ADHERENT_VGM' } });
                  return;
                }

                if (~user.roles.indexOf('COM_ALI_LECTURE_PERSONNELLE')) {
                  this.$router.push(this.$route.query.redirectFrom || { name: 'main' });
                } else {
                  this.$router.push(this.$route.query.redirectFrom || { name: 'admin.connect_as.selection_tiers' });
                }
              }).catch(err => {
                let cause = null;
                if (err && err.response && err.response.status === 403) {
                  cause = 'ACCES_NON_AUTHORISE';
                }

                router.push({ name: 'error-logout', query: { cause } });
              });
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
          this.error = error;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<template>
  <v-main>
    <v-overlay
      :opacity="0"
      :value="loading"
    />

    <v-container
      fluid
      fill-height
    >
      <v-layout
        row
        align-center
        justify-center
      >
        <div class="card">
          <v-layout column>
            <img
              src="../assets/images/logo_cdea.png"
              class="logo mb-10"
            >

            <v-btn
              color="primary"
              block
              rounded
              outlined
              :loading="loading"
              @click="login"
            >
              Se connecter
            </v-btn>

            <div
              v-if="error"
              class="mt-3 error--text"
            >
              Erreur d'authentification.
            </div>
          </v-layout>
        </div>
        <div
          v-if="!isMobile"
          class="l-spacer"
        />
      </v-layout>
    </v-container>
  </v-main>
</template>

<style lang="scss" scoped>
.logo{
  width: 300px;
  max-width: 100%;
  height: auto;
}

.layout{
  width: 100%;
}

.card{
  background-color: rgba(255,255,255,0.95);
  padding: 2em;
  border-radius: 8px;
}

.l-spacer{
  width: 30%;
  height: 10px;
}

.v-main {
  background-color: white;
  background-image: url('../assets/images/bg-login-desktop.png');
  background-position: top right;
  background-repeat: no-repeat;
  background-size: auto 100%;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .v-main {
    background-image: url('../assets/images/bg-login-mobile.png');
    background-size: auto;
  }
}

</style>
